import { useEffect } from 'react';
import { PublicLegacyOperatorDetailsResponse } from 'src/apis/organisation-service/types';
import { useAxios } from 'src/hooks/use-axios';
import urlTemplate from 'url-template';

type HookOptions = {
  organisationId?: string; // TODO: If you pass undefined, the hook should return nothing to reflect it.
  url: string;
};

type ExecuteOptions = {
  organisationId: string;
  url: string;
};

/**
 * This can be used to get either TSO or SSO details (depending on the url).
 * LSO details are not supported.
 */
export function usePublicLegacyOperatorDetails({
  organisationId,
  url,
}: HookOptions) {
  const operatorDetails = useAxios(
    (axios, signal, { url, organisationId }: ExecuteOptions) =>
      axios.request<PublicLegacyOperatorDetailsResponse>({
        signal,
        url: urlTemplate.parse(url).expand({ organisationId }),
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    if (!organisationId) return;
    operatorDetails.execute({ organisationId, url });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url, organisationId]);

  return operatorDetails;
}

export type OrganisationDetailsRequest = ReturnType<
  typeof usePublicLegacyOperatorDetails
>;
